import {Component, Input, OnChanges} from "@angular/core";

/**
 * Une part du camembert : la classe CSS qui porte sa couleur et les deux
 * attributs SVG qui la positionnent sur le cercle.
 */
interface PieSlice {
    className: string;
    dashArray: string;
    dashOffset: number;
}

/**
 * Camembert générique de répartition succès / échec, dans cet ordre, avec une
 * troisième part facultative pour ce qui n'est pas encore tranché.
 *
 * Le composant ne connaît pas le domaine : les compteurs et l'infobulle sont
 * calculés par l'appelant, qui seul sait s'il parle d'épreuves d'un candidat
 * (onglet Tickets) ou de tickets d'une session (onglet Sessions).
 */
@Component({
    "selector": "app-success-pie",
    "templateUrl": "./success-pie.component.html",
    "styleUrls": ["./success-pie.component.scss"]
})
export class SuccessPieComponent implements OnChanges {

    @Input() succeeded = 0;

    @Input() failed = 0;

    @Input() pending = 0;

    @Input() tooltip = "";

    // Rayon de la ligne médiane du trait, dans le repère du viewBox
    readonly radius = 8;

    readonly circumference = 2 * Math.PI * this.radius;

    total = 0;

    slices: Array<PieSlice> = [];

    ngOnChanges (): void {
        this.total = this.succeeded + this.failed + this.pending;
        this.slices = this.buildSlices();
    }

    /**
     * Découpe le cercle en arcs consécutifs, chacun décalé de la longueur
     * cumulée des précédents.
     */
    private buildSlices (): Array<PieSlice> {
        if (this.total === 0) {
            return [];
        }

        const counts = [
            {"className": "slice-succeeded", "count": this.succeeded},
            {"className": "slice-failed", "count": this.failed},
            {"className": "slice-pending", "count": this.pending}
        ];

        const slices: Array<PieSlice> = [];
        let consumed = 0;

        counts.forEach((part) => {
            if (part.count === 0) {
                return;
            }

            const length = this.circumference * part.count / this.total;

            slices.push({
                "className": part.className,
                "dashArray": `${length} ${this.circumference}`,
                "dashOffset": -consumed
            });

            consumed += length;
        });

        return slices;
    }

}
